import * as Msal from 'msal';

export default class AuthService {
  constructor(clientid, authUri, signUpUri, redirect, redirectlogout) {
    this.signupAuth = signUpUri;

    try {
      this.app = new Msal.UserAgentApplication(
        {
          auth: {
            clientId: clientid,
            authority: authUri,
            redirectUri: redirect,
            validateAuthority: false,
            postLogoutRedirectUri: redirectlogout,
          },
          cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false,
          },
          system: {
            windowHashTimeout: 60000,
            iframeHashTimeout: 6000,
            loadFrameTimeout: 90000,
          },
        }
      );
    }
    catch (error) {
      // eslint-disable-next-line
      console.error(`Error loading MSAL client. Error was ${error}`);
      throw error;
    }

    // comment to add hook to authentication callback from msal
    // eslint-disable-next-line
    this.app.handleRedirectCallback((error, response) => {
      // eslint-disable-next-line
      // Todo: anything to do on user auth callback
      if (response && response.idToken && window.$router && response.account && response.account.idToken.tfp != "B2C_1_password_reset") {
        return window.$router.go("/Varsler");
      }
      if (error && error.errorCode == "access_denied") {
        // eslint-disable-next-line
        console.log("Password changed. User must log in again.");
        return this.app.logout();
      }
    });
  }

  async checkLogin() {
    if (this.validateUser()) return this.login(true);
    return null;
  }

  async login(onlyCheck) {
    try {
      await this.app.acquireTokenSilent({ scopes: ['profile'] });
    } catch (error) {
      if (!onlyCheck)
        return this.loginWithRedir();
    }

    const user = this.getUser();
    return user;
  }

  signup() {
    this.app.loginRedirect({ authority: this.signupAuth });
  }

  loginWithRedir() {
    this.app.loginRedirect({ scopes: ['openid'] });
  }

  logout() {
    this.app.logout();
  }

  getUser() {
    return this.app.getAccount();
  }

  getToken() {
    return this.app.getAccount().idToken;
  }

  validateUser() {
    const user = this.getUser();
    return user != null;
  }
}
